import { Directive, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[appDragToTop]',
  standalone: true
})
export class DragToTopDirective implements OnInit {
  private readonly route = inject(Router)

  ngOnInit(): void {
    this.setValueChanges()
  }

  setValueChanges() {
    this.route.events.subscribe(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'instant' })
    })
  }
}
